<template>
  <div>
    <div v-if="!showResults" ref="test" class="test">
      <div class="test__type">
        {{ $t('evaluation.evaluation') }}:
        <span class="text-capitalize text-white">{{
          isFullEvaluation ? $t('evaluation.fullEvaluation') : $t('evaluation.lightEvaluation')
        }}</span>
      </div>
      <div v-loading="loading" class="test__container">
     
        <div class="question">
          <div class="question__info">
            <h1 class="question__info-text text-uppercase">
              {{ $t('testTest.doubleClickCorrect') }}
            </h1>
            <span class="question__count">{{ selectedQuestionIndex + 1 }} / {{ questions.length }}</span>
                 <div class="btn-exit" @click="$emit('close')">
        <img src="@/assets/icons/menu/windows_control/Close_1.svg" alt />
        <!-- {{ $t('pretest.exit') }}ccccccc -->
      </div>
          </div>
          <div v-if="questions.length" class="py-2 px-1">
            <h3 class="question__text">{{ questions[selectedQuestionIndex].text }}</h3>
            <h2 class="question__example">{{ questions[selectedQuestionIndex].example }}</h2>
            <template v-if="questions[selectedQuestionIndex].type === 'M'">
              <ul class="question__multiple-choices">
                <template v-for="option in questions[selectedQuestionIndex].options">
                  <li v-if="option" :key="option" class="question__multiple-choices-item">
                    <button
                      :class="[
                        'btn',
                        'question__multiple-choices-item-button',
                        { 'question__multiple-choices-item-button--active': userAnswer === option },
                      ]"
                      @click="userAnswer = option"
                    >
                      {{ option }}
                    </button>
                  </li>
                </template>
              </ul>
            </template>
            <template v-if="questions[selectedQuestionIndex].type === 'B'">
              <ul class="question__two-choices">
                <template v-for="option in questions[selectedQuestionIndex].options">
                  <li v-if="option" :key="option" class="question__two-choices-item">
                    <button
                      :class="[
                        'btn',
                        'question__two-choices-item-button',
                        { 'question__two-choices-item-button--active': userAnswer === option },
                      ]"
                      @click="userAnswer = option"
                    >
                      {{ option }}
                    </button>
                  </li>
                </template>
              </ul>
            </template>
            <template v-if="questions[selectedQuestionIndex].type === 'T'">
              <div class="question__write-answer">
                <input v-model="userAnswer" type="text" class="question__write-answer-input form-control" />
              </div>
            </template>
          </div>
          <div class="question__actions">
            <button class="btn btn-skip" :disabled="userAnswer" @click="nextQuestion">
              {{ $t('testTest.skip') }}
            </button>
            <button class="btn btn-submit" :disabled="!userAnswer" @click="handleUserAnswer">
              {{ $t('testTest.submit') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <result v-else :test="test" />
  </div>
</template>
<script>
import moment from 'moment';
import result from './Results.vue';
import _ from 'lodash';

export default {
  name: 'Test',
  filters: {
    OnlyQuestion: value => {
      let response;
      if (value.indexOf('?') > -1) {
        response = value.split('?');
        return `${response[0]}?`;
      }
      if (value.indexOf('"') > -1) {
        response = value.split('"');
        return response[0];
      }
      if (value.indexOf('.') > -1) {
        response = value.split('.');
        return response[0];
      }
      return value;
    },
    OnlyExample: value => {
      let response;
      if (value.indexOf('?') > -1) {
        response = value.split('?');
      }
      if (value.indexOf('"') > -1) {
        response = value.split('"');
      }
      if (value.indexOf('.') > -1) {
        response = value.split('.');
      }
      return response[1];
    },
  },
  components: {
    result,
  },
  props: {
    gradeId: {
      type: Number,
      required: true,
    },
    subjectId: {
      type: [Number, null],
      required: true,
    },
    studentId: {
      type: Number,
      required: true,
    },
    isFullEvaluation: {
      type: Boolean,
      required: true,
    },
    studentName: {
      type: String,
      required: true,
    },
    gradeName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      questionStartDate: null,
      showResults: false,
      questions: [],
      selectedQuestionIndex: 0,
      timePerQuestion: 120000,
      loading: false,
      userAnswer: null,
      test: {
        userId: this.studentId,
        studentName: this.studentName,
        gradeName: this.gradeName,
        isFullEvaluation: this.isFullEvaluation,
        questionsCorrect: 0,
        wrongQuestions: 0,
        average: 0,
        startedDate: null,
        finishDate: null,
        subjectId: this.subjectId,
        gradeId: this.gradeId,
        // clusterId: Number.parseInt(this.$route.params.cluster_id),
        questions: [],
        // details: [],
      },
    };
  },
  watch: {
    selectedQuestionIndex(newIndex) {
      console.log(this.questions[newIndex].answer_correct);
    },
  },
  created() {
    this.fetchQuestions();
    this.test.startedDate = moment().format();
   
  },
  methods: {
    handleUserAnswer() {
      let answerCorrect = this.questions[this.selectedQuestionIndex].answer_correct;
      const questionType = this.questions[this.selectedQuestionIndex].type;

      if (this.questions[this.selectedQuestionIndex].type === 'T') {
        answerCorrect = this.questions[this.selectedQuestionIndex].answer_correct.toLowerCase();
        this.userAnswer = this.userAnswer.toLowerCase();
      }
      if (this.userAnswer === answerCorrect) {
        questionType === 'M'
          ? (this.test.average += 9.75)
          : null || questionType === 'B'
          ? (this.test.average += 9.5)
          : null || questionType === 'T'
          ? (this.test.average += 10)
          : null;

        // La pregunta fue respondida correctamente
        this.questions[this.selectedQuestionIndex].answered_correctly = true;
        this.test.questionsCorrect++;
        // this.test.details.push({
        //   started_date: this.questionStartDate,
        //   ended_date: moment().format(),
        //   question_id: this.questions[this.selectedQuestionIndex].id,
        //   lesson_id: this.questions[this.selectedQuestionIndex].lesson_id,
        //   cluster_id: this.questions[this.selectedQuestionIndex].cluster_id,
        //   user_id: this.studentId,
        //   answered_correctly: true,
        //   user_answer: this.userAnswer,
        //   subject_id: this.questions[this.selectedQuestionIndex].subject_id,
        // });
      } else {
        // La pregunta fue respondida in correctamente
        this.questions[this.selectedQuestionIndex].answered_correctly = false;
        this.test.wrongQuestions++;
        // this.test.details.push({
        //   started_date: this.questionStartDate,
        //   ended_date: moment().format(),
        //   question_id: this.questions[this.selectedQuestionIndex].id,
        //   lesson_id: this.questions[this.selectedQuestionIndex].lesson_id,
        //   cluster_id: this.questions[this.selectedQuestionIndex].cluster_id,
        //   user_id: this.studentId,
        //   answered_correctly: true,
        //   user_answer: this.userAnswer,
        //   subject_id: this.questions[this.selectedQuestionIndex].subject_id,
        // });
      }

      this.nextQuestion();
    },
    nextQuestion() {
      const question = this.questions[this.selectedQuestionIndex];
      this.test.questions.push({ ...question, user_answer: this.userAnswer });

      if (this.selectedQuestionIndex < this.questions.length - 1) {
        this.selectedQuestionIndex++;
        this.userAnswer = null;
        this.questionStartDate = moment().format();
        return;
      }
      this.testFinished();
    },
    fetchQuestions() {
      this.loading = true;
      if (this.subjectId === 0) {
        this.$httpMain
          .post(`questions/grade`, {
            grade_id: this.gradeId,
            per_page: this.isFullEvaluation ? 2 : 1,
          })
          .then(res => {
            this.questions = res.data;
          })
          .finally(() => {
            this.transformText();
            this.loading = false;
          });
      } else {
        this.$httpMain
          .post(`/questions/subject`, {
            subject_id: this.subjectId,
            per_page: this.isFullEvaluation ? 2 : 1,
          })
          .then(res => {
            this.questions = res.data;
            this.questionStartDate = moment().format();
          })
          .finally(() => {
            this.transformText();
            this.loading = false;
          });
      }
    },
    transformText(){
      this.questions.forEach(element => {
        console.log(element);
        element.text= this.capitalizarPrimeraLetra(element.text);
        if(element.example!=null){
          element.example= this.capitalizarPrimeraLetra(element.example);
        }
        element.answer_correct=this.capitalizarPrimeraLetra(element.answer_correct);
        if(element.options){
          for (let index = 0; index < element.options.length; index++) {
           console.log(element.options[index]); 
           if(element.options[index]!=null){
             element.options[index]=this.capitalizarPrimeraLetra(element.options[index]);
           }
          }
        }
      });
    },
    capitalizarPrimeraLetra(str) {
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    },
    testFinished() {
      // if (this.questions.length === 7) {
      //   this.test.average = Math.floor((this.test.questionsCorrect * 100) / 7);
      // }
      // if (this.questions.length === 10 && this.test.correctAnswers === 7) {
      //   this.test.average = 70;
      // }
      // if (this.questions.length === this.test.questionsCorrect) {
      //   this.test.average = 100;
      // }
      this.test.finishDate = moment().format();

      this.saveResult();
    },
    saveResult() {
      var payload = [];
      let subjects = _.groupBy(this.test.questions, 'subject_id');
      Object.keys(subjects).forEach(key => {
        var correctAnswers = 0;
        subjects[key].forEach(question => {
          if (question.answered_correctly) {
            correctAnswers++;
          }
        });
        var value = (correctAnswers * 100) / _.size(subjects[key]);
        value % 1 === 0 ? value : value.toFixed(2);

        payload.push({ subject_id: Number.parseInt(key), average: value, grade_id: this.gradeId });
      });

      this.loading = true;
      this.$httpMain
        .post(`evaluation`, {
          student_id: this.studentId,
          subjects: payload,
        })
        .then(res => {
          console.log(res);
          this.showResults = true;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.test{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-bottom: 1em;
  padding-top: 2em;
  @media (min-width: 576px) {
    padding-top: 1em
  }
  @media (min-width: 992px) {
   min-height: 70vh
  }
  &__container{
 position: relative;
    overflow-y: auto;
    box-shadow: 5px 5px 10px rgba(0,0,0,.5);
    border-radius: 30px;
    background-color: #fff;
    width: 100%;
    @media (min-width: 576px) {
    margin-top: .5em;
      width: 98%;
  }
  @media (min-width: 992px) {
    margin-top: unset;
      width: 850px;
      height: 600px;
  }
    @media (max-height: 500px){
      height: 465px;
    }
  }
  &__type{
background-color: #00b9ff;
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
    padding: .2em .5em;
    color: #626262;
  }

}

 

.question{
  &__info{
      background-color: #00b9ff;
      border-top-left-radius: 30px;
      border-top-right-radius: 30px;
      text-align: center;
      padding: 1em;
      color: #fff;
      position: relative;
        @media (min-width: 992px) {
        display: flex;
        align-items: unset;
        justify-content: unset;
        }

  }
  &__count{
        @media (min-width: 576px) {
          margin-left: 20px

        }

  }
  &__info-text{
      font-size: 18px;
      margin-bottom: .5em;
       @media (min-width: 576px) {
        margin-bottom: 0
       }
  }
  &__text{
      font-size: 14px;
      font-weight: 600;
      text-align: center;
      margin-bottom: 1em;
  }
  &__example{
      font-size: 16px;
      font-weight: 400;
      text-align: center;
      margin-bottom: .5em;
  }
  &__multiple-choices{
      @media (min-width: 768px) {
          margin-top: 1em;
          columns: 2;
          -webkit-columns: 2;
          -moz-columns: 2;

      }
      @media (min-width: 992px) {
        columns: unset

      }
  }
  &__multiple-choices-item{
      font-size: 12px;
      background-color: #dfe9f0;
      border-radius: 5px;
      font-family: comfortaabold;
      text-transform: uppercase;
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 4em;
      margin-bottom: .5em;
      margin-top: .5em;
        @media (min-width: 576px) {
            margin-bottom: .5em;
            margin-top: 0;
        }
       @media (min-width: 992px) {
         margin-bottom: 1em
       }
  }
  &__multiple-choices-item-button{
      min-height: 4em;
      width: 100%;
      height: 100%;
      &:focus{
        background-color: #ff6d00;
        outline: none;
        box-shadow: none;
      }
      &:active{
        background-color: #ff6d00;
        color: #fff;

      }
  }
  &__two-choices{
      margin-top: 2em;
      columns: 2;
      -webkit-columns: 2;
      -moz-columns: 2;
  }
  &__two-choices-item{
      font-size: 12px;
      background-color: #dfe9f0;
      border-radius: 5px;
      font-family: comfortaabold;
      text-transform: uppercase;
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 4em;
      margin-bottom: .5em;
      margin-top: .5em;
       @media (min-width: 576px) {
           margin-bottom: .5em;
           margin-top: 0;

       }
      @media (min-width: 992px) {
        margin-bottom: 1em
      }

  }
  &__two-choices-item-button{
      min-height: 4em;
      width: 100%;
      height: 100%;
      &:focus{
        background-color: #ff6d00;
        outline: none;
        box-shadow: none;
      }
      &:active{
          background-color: #ff6d00;
          color: #fff;
      }
  }
  &__write-answer{
      margin-top: 2em;
      margin-bottom: 2em;
  }
  &__write-answer-input{
      width: 250px;
      margin: auto;
  }
  &__actions{
      display: flex;
      justify-content: space-around;
      margin-bottom: 1em;
       @media (min-width: 992px) {
         position: absolute;
         bottom: 1em;
         left: 0;
         right: 0;
       }
  }

.btn-skip,
.btn-submit{
  justify-self: center;
  color: #ffffff;
  padding: 5px;
  font-family: 'comfortaabold';
  font-weight: bold;
  font-size: 18px;
  width: 130px;
  height: 35px;

}
.btn-skip{
  background-color: #ff6d00;
  &:focus{
    box-shadow: 0 0 0 3px rgba($color: #ff6d00, $alpha: 0.5);
  }

}
.btn-submit{
  background-color: #7ac35c;
  &:disabled{
    background-color: #a0a0a0 !important;
  }
  &:focus{
    box-shadow: 0 0 0 3px rgba($color: #7ac35c, $alpha: 0.5);
  }
}
.btn-exit{
  // position: absolute
    //bottom: 0
    right: 0;
    color: #ffffff;
    //background-color: #ff1800;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
    font-family: 'comfortaabold';
    font-weight: bold;
    font-size: 18px;
    display: flex;
    align-items: center;
    img{
      //margin-right: 10px
      width: 30px;
      cursor: pointer;
    }
}
}
</style>
